// extracted by mini-css-extract-plugin
export default {"root":"Container_root__cDbVV","fullWidth":"Container_fullWidth__bGTJP"};